import { Component, Input } from '@angular/core';
import {
	INTERACTION_TYPE,
	ITEM_TYPE,
	SCOPE_TYPE,
	SUBSCOPE_TYPE,
} from 'app/interfaces/actiontracker.interface';
import { IContact } from 'app/interfaces/contact.interface';
import { ICalendarEvent } from 'app/interfaces/event.interface';
import { ITask } from 'app/interfaces/task.interface';
import { ActionTrackerService } from 'app/services/actiontracker.service';
import { TabActivatedEvent } from 'shared/components/tab-panel/tab-panel.component';
import { PromptuaryService } from 'shared/services/promptuary/promptuary.service';

@Component({
	selector: 'appointment-details-body',
	templateUrl: './appointment-details-body.component.html',
})
export class AppointmentDetailsBodyComponent {
	@Input()
	public isFirstSession = false;

	@Input()
	public event: ICalendarEvent;

	@Input()
	public contact: IContact;

	@Input()
	public sessionTask: ITask;

	@Input()
	public sessionHasTask: boolean;

	constructor(
		public promptuaryService: PromptuaryService,
		public actionTrackerService: ActionTrackerService
	) {}

	public trackTabActivated(tabActivatedEvent: TabActivatedEvent): void {
		this.actionTrackerService.eventTracker(
			SCOPE_TYPE.Appointment,
			SUBSCOPE_TYPE.Details,
			ITEM_TYPE.Tab,
			INTERACTION_TYPE.Click,
			{
				tab: tabActivatedEvent.activatedTab === 0 ? 'details' : 'history',
			}
		);
	}

	public isScreeningSession(): boolean {
		return this.event.subscription?.coordinatedCareType === 'screening';
	}
}
